import Skeleton from "react-loading-skeleton";
import { TableBody } from "react-aria-components";

import { Cell2 } from "@/ui2/atoms/(table)/Cell";
import { Row2 } from "@/ui2/molecules/(table)/Row";

import { PAGE_SIZE } from "../../constants";

const skeletonRows = Array.from({ length: PAGE_SIZE }, (_, i) => ({ id: String(i) }));

export function CsmTableSkeleton() {
  return (
    <TableBody items={skeletonRows}>
      {({ id }) => (
        <Row2 id={id} isDisabled>
          <Cell2>
            <Skeleton width="65%" />
          </Cell2>
          <Cell2>
            <Skeleton width="75%" />
          </Cell2>
          <Cell2>
            <Skeleton width={90} />
          </Cell2>
          <Cell2>
            <Skeleton width={60} />
          </Cell2>
          <Cell2>
            <Skeleton width={24} />
          </Cell2>
        </Row2>
      )}
    </TableBody>
  );
}
